<template>
  <div class="l-edit-dialog-box jt-v-form-dialog">
    <div v-loading="loading">
        <div>
            <div class="l-simple-search-container">
        
            <div class="input-with-select" style="display:inline-block;margin-right:10px">
                <span class="mr1">关键词：</span>
                <el-input placeholder="请输入关键词" v-model="searchData.keyword" class="input-with-select" style="width: 76%;">
                    <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                </el-input>
            </div>
            <div class="input-with-select" style="display:inline-block;margin-right:10px">
                <span class="mr1">日期：</span>
            <el-date-picker v-model="value2" type="daterange" autocomplete="off" @blur="onPick(false)" clearable value-format="yyyy-MM-dd" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick(false)">
            </el-date-picker>
            </div>
            <div class="input-with-select" style="display:inline-block;margin-right:10px;">
                <span class="mr1">整改状态：</span>
                <div class="l-show-more-search">
                <el-select v-model="searchData.modify_state" placeholder="全部" clearable>
                    <el-option v-for="(item, index) in MODIFY_LIST" :key="index" :label="item" :value="index"> </el-option>
                </el-select>
                </div>
            </div>
            <div class="input-with-select" style="display:inline-block;margin-right:10px;">
                <span class="mr1">隐患等级：</span>
                <div class="l-show-more-search">
                <el-select v-model="searchData.danger_level" placeholder="全部" clearable>
                    <el-option v-for="(item, index) in LEVEL" :key="index" :label="item" :value="index"> </el-option>
                </el-select>
                </div>
            </div>
            
  
        </div>
        
        </div>
      <div class="l-primary l-table-config flex justify-between items-center">
      <el-popover placement="bottom-start" width="200" trigger="click" popper-class="l-table-column-fixed-select-box">
        <span slot="reference">
          <i class="el-icon-setting"></i>表格列表配置
        </span>
        <div class="">
          <div class="l-flex l-flex-just-between" style="margin-bottom:10px">
            <div>
              表格列表配置
              <i class="el-icon-refresh-left" style="float:right;  color: red;margin: 3px;" @click="resetFixedCheck">重置</i>
            </div>
          </div>
          <el-divider class="l-table-column-fixed-title-divider"></el-divider>
          <el-checkbox-group v-model="fixed_list">
            <div v-for="(item,index) in columns" :key="index">
              <el-checkbox :label="item.prop" style="margin-bottom:4px">
                {{item.label}}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </el-popover>

      <div style="float: right;" @click="search_visible = true">
       <l-auth-button type="info" auth="hidden_danger_tracking_info" @click="exportExcel" :loading="export_loading"> 导出EXCEL </l-auth-button>
      </div>

    </div>
         <l-table :data="data" row-key="id" height="500px">
      <el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" :label="item.label" show-overflow-tooltip>
        <template v-slot="{ row }">
          <template v-if="item.prop == 'name'">
            <a class="link-color" @click="placeInfo(row.place_id)"> {{ row.name}}</a>
          </template>

          <template v-else-if="item.prop == 'danger_lavel'">
            <el-tag type="danger" size="small" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
          </template>
          <template v-else>
            {{ row[item.prop] }}
          </template>
        </template>
      </el-table-column>

    </l-table>
<!--分页-->
      <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>
    </div>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
    </div>

    <!--场所详情-->
    <l-dialog :visible.sync="place_info_visible" title="场所信息" width="1600px">
      <l-place-info :visible.sync="place_info_visible" :id="place_id" is-info />
    </l-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { LEVEL } from '../rental/rental';
import PlaceInfo from "../place/Info.vue";
import {MODIFY_LIST} from "./modify";
export default {
    name:"l-danger-list-info",
    components: {
    [PlaceInfo.name]: PlaceInfo,
  },
    props: {
    // id: {
    //   type: [Number, String],
    //   default: null,
    // },
    visible: {
      type: Boolean,
    },
    searchData: {
      type: [Object],
      required: true,
    },
  },
  computed: {
    columns() {
      let columns = [
        {
          prop: "place_sn",
          label: "场所编码",
          fixed: true,
          Width: "140",
        },
        {
          prop: "name",
          label: "场所名称",
          fixed: true,
          Width: "140",
        },
        {
          prop: "null",
          label: "场所类型",
          fixed: true,
          width: "140",
        },
        {
          prop: "danger_lavel",
          label: "隐患等级",
          fixed: true,
          width: "80",
        },
        {
          prop: "danger",
          label: "隐患描述",
          fixed: true,
          width: "200",
        },
        {
          prop: "rectification",
          label: "隐患整改",
          fixed: true,
          width: "200",
        },


      ];

      let result = columns.map((item) => {
        const index = this.fixed_list.findIndex((itm) => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }

        return item;
      });

      return result;
    },
  },
  data(){
    return {
        MODIFY_LIST:MODIFY_LIST,
        LEVEL:LEVEL,
        data:[],
        loading:false,
        export_loading:false,
        count:0,
        page: 1,
        page_size: Vue.$_config.page.page_size,
        re_fixed_list: ["index", "order_sn"],
        fixed_list: ["index", "order_sn"],
        place_info_visible:false,//场所详情弹出
      place_id:"",
      value2: '',
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getList();
        }
      },
    },
    fixed_list(val) {
      if (val.length > 2) {
        this.fixed_list.shift();
      }
    },
  },
  methods: {
    //时间搜索
    onPick(cant) {
      if (!this.value2) {
        this.value2 = "";
        this.searchData.start_time = "";
        this.searchData.end_time = "";
      } else {
        this.searchData.start_time = this.value2[0];
        this.searchData.end_time = this.value2[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },
    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.getList();
    },
    //打开场所详情
    placeInfo(id) {
      this.place_id = id;
      this.$nextTick(() => {
        this.place_info_visible = true;
      });
    },
    exportExcel(){},
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },
    getList() {
      this.loading = true;
      this.$_invoke("hiddenDanger_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.searchData,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },

  }
}
</script>

<style lang="scss" scope>
.l-table-config{
    margin-bottom: 20px;
}
.l-table-toolbar{
    width: 100%;
}
.input-with-select{
    margin-bottom: 10px;
}
.l-simple-search-container{
    float: none;
}
</style>